import React from 'react';
import { Container, Title, Form, ButtonContent } from './styles';
import { Button, FormController } from '../../../assets/global/globalStyles';
import {
  resetWarehouseState,
  httpRequestWarehouse,
  fetchWarehouse,
} from '../../../store/warehouse';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { warehouseForm } from '../../../utils/formVerifications';
import { useDispatch, useSelector } from 'react-redux';
import MetaTitle from '../../MetaTitle';
import Input from '../Input';
import {
  createWarehouse,
  editWarehouse,
  getWarehouseById,
} from '../../../utils/httpRequest';
import SelectC from '../Select';

export default function FormWarehouse() {
  const warehouse = useSelector((state) => state.warehouse.data);
  const user = useSelector(state => state.user)
  const [title, setTitle] = React.useState('Cadastrar');
  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    setTitle(id ? 'Editar' : 'Cadastrar');

    if(id && !warehouse?.id && !user.loading){
      dispatch(fetchWarehouse(getWarehouseById(id)));
    }
    return () => {
      dispatch(resetWarehouseState());
    };
  }, [dispatch, id, user]);

  const handleSubmit = async (data) => {
    formRef.current.setErrors({});
    const { payload, error } = await warehouseForm(data);
    if (error) return formRef.current.setErrors(error);
    if (payload) {
      const data = {
        branchName: payload.branchName,
        codeSap: payload.codeSap,
        name: payload.name,
        address: payload.address,
        number: String(payload.number),
        city: payload.city,
        latitude: payload.latitude,
        longitude: payload.longitude,
        status: payload.status
      }
      
      if(id){
        data.id = Number(id)
      }

      const { success } = await dispatch(
        httpRequestWarehouse(
          id
            ? editWarehouse(data)
            : createWarehouse(data),
        ),
      );
      if (success) navigate(-1);
    }
  };

  return (
    <Container>
      <MetaTitle title={`${title} Depósito`} />
      <Title>{title} Depósitos</Title>
      <Form
        ref={formRef}
        initialData={warehouse}
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Input
          name="codeSap"
          label="Código do Depósito: *"
          grid="1/3"
          disabled={id}
        />
        <Input
          name="name"
          label="Nome do Depósito: *"
          grid="3/6"
          disabled={id}
        />
        <Input name="address" label="Endereço: *" grid="1/-1" />
        <SelectC
          defaultValue="A"
          label="Status: "
          name="status"
          grid="1/2"
          options={[
            {
              value: 'A',
              label: 'Ativo',
            },
            {
              value: 'I',
              label: 'Inativo',
            },
          ]}
        />
        <Input name="city" label="Cidade: *" grid="2/5" />
        <Input name="number" type="number" label="Número: *" />
        <SelectC
          defaultValue="A"
          label="Fialial: "
          name="branchName"
          grid="1/2"
          options={[
            {
              value: "CPFL",
              label: "CPFL"
            },
            {
              value: "RGE",
              label: "RGE"
            }
          ]}
        />
        <Input name="latitude" grid="2/4" label="Latitude: *" />
        <Input name="longitude" grid="4/6" label="Longitude: *" />
        <FormController grid="1/-1">
          <ButtonContent>
            <Button type="submit" typeName="success">
              Enviar
            </Button>
            <Link to="/dashboard/warehouse">
              <Button type="button" typeName="welcome">
                Voltar
              </Button>
            </Link>
          </ButtonContent>
        </FormController>
      </Form>
    </Container>
  );
}
